import { GridRowStyled, TypographyWithOverflowHint } from '@schooly/style';
import { GridRowItem } from '@schooly/style';
import { FC } from 'react';

import { ListViewAssessmentEntriesHeaderCell } from './ListViewAssessmentEntriesRow.styled';

type ListViewAssessmentEntriesHeaderProps = {
  title?: string;
  content?: React.ReactNode;
};

export const ListViewAssessmentEntriesHeader: FC<ListViewAssessmentEntriesHeaderProps> = ({
  title,
  content,
}) => {
  return (
    <GridRowStyled>
      <GridRowItem>
        <ListViewAssessmentEntriesHeaderCell>
          {title && (
            <TypographyWithOverflowHint color="text.primary" variant="h3">
              {title}
            </TypographyWithOverflowHint>
          )}

          {content}
        </ListViewAssessmentEntriesHeaderCell>
      </GridRowItem>
    </GridRowStyled>
  );
};
